<template>
<div class="main">

  <div class="left-container">
    <Navigation :lang="lang" />
    <Page  v-if="!searchPage" @refreshMap="showMap" />
    <Search v-else :viewModeProp="searchViewMode" :lang="lang" @refreshMap="showMap" />
    <Footer :lang="lang"/>
  </div>

  <div class="right-container">
    <SideNavigation :lang="lang" />
  </div>

  <div class="search-map-autocomplete" v-if="this.isAuthenticated && isAdjustMap">  
    <form>
    <input 
      type="text" 
      placeholder="Code Postal, Pays" 
      v-model="placeToSearch" 
      v-on:keydown.enter.prevent='getMapData'
       >
    </form>
  </div>

  <div class="tools map-update" v-if="this.isAuthenticated">
    <button v-if="!(searchPage)" class="btn circle medium" @click="adjustMap" :class="{ active: isAdjustMap }">
      <span class="tooltip">Carte</span><i class="fa fa-map"></i>
    </button>
  </div>

  <div class="map-container" :class="{ ontop: isAdjustMap || searchViewMode == 'map' }">
    <div v-if="!(searchPage || isAdjustMap)" class="map-overlay"></div>
    
    <div v-if="mapIsReady && membres && searchViewMode == 'map'">
      
      <MapMarker
        v-for="membre in membres" 
        :markerdata="membre"
        :lang="lang">
        {{membre.title}}
      </MapMarker>


<!--       <div
        v-for="membre in membres" 
        :markerdata="membre">
        {{membre.title}}
      </div> -->

<!--       <div class="not-on-map" v-if="membresNotInMap">
        <h4>Hors France Métropolitaine</h4>
        <router-link 
          v-for="membre in membresNotInMap" 
          class="mapboxgl-marker mapboxgl-marker-anchor-center always-active" 
          :to="{path: membre.url}" :tag="'button'">
          <div class="label">{{membre.title}}</div>
        </router-link>
      </div> -->
    </div>

    <Mapbox
      :access-token="'pk.eyJ1IjoiYmVub2l0YiIsImEiOiJjamV6ZG5vaWwwOXd1MnhvaDlyZTRsM2VnIn0.hyAyyxR_bD_XIYiam8rvXg'"
      :map-options="mapOptions"
      :scale-control="{show: true, position: 'top-left', }"
      @map-init="mapInitialized"
      @map-load="mapLoaded">
    </Mapbox>

  </div>

</div>
</template>

<script>

import { mapGetters } from 'vuex'
import Navigation from './Navigation'
import Search from './Search'
import Page from './Page'
import SideNavigation from './SideNavigation'
import Footer from './Footer'
import Mapbox from 'mapbox-gl-vue'
import axios from 'axios'
import Autocomplete from 'vuejs-auto-complete'
import MapMarker from './Map/MapMarker'

global.map = 'test'

export default {
  name: 'Main',
  components: {
    Navigation,
    Search,
    Page,
    SideNavigation,
    Mapbox,
    Autocomplete,
    MapMarker,
    Footer    
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userAuthenticated'
    ]),
    membresNotInMap () {
      if (this.membres) {
        this.membres.filter(obj => {
          return JSON.parse(obj.location).notOnMap === true
        })
      }
    }
  },
  props: {
    searchPage: true,
    searchViewMode: true
  },
  data () {
    return {
      lang: 'fr',
      title: 'Chargement',
      content: '',
      mapIsReady: false,
      isAdjustMap: false,
      placeToSearch: '',
      mapOptions: {
        container: 'map', // container id
        style: 'mapbox://styles/benoitb/cji1sxjd4026c2rppx6ird8wo',
        center: [-2.744718287750402, 47.73561377382407], // starting position [lng, lat]
        zoom: 20, // starting zoom
        bearing: 0,

        scrollZoom: false
      },
      selectedLocations: [
        { "long" : -2.744718287750402, "lat" : 47.73611377382407, "zoom" : 20 },
        { "long" : -3.0540392957889253, "lat" : 48.20081151735839, "zoom" : 17 },
        { "long" : 2.155485060858382, "lat" : 48.938236634860414, "zoom" : 14 },
        { "long" : -3.0451839414557753, "lat" : 48.48565012002824, "zoom" : 19 },
        { "long" : 7.750452924019555, "lat" : 48.38966857665204, "zoom" : 20 },
        { "long" : 1.5983325939261022, "lat" : 49.55355059600022, "zoom" : 19 },
        { "long" : 1.8662377464429483, "lat" : 45.803253518836056, "zoom" : 16 },
        { "long" : 3.064381354143052, "lat" : 50.639616237167315, "zoom" : 14 },
        { "long" : 5.358337774633924, "lat" : 43.413813487831516, "zoom" : 20 },
        { "long" : 3.0712569458173675, "lat" : 50.67596175585383, "zoom" : 19 },
        { "long" : 7.542465459433515, "lat" : 50.312521334988446, "zoom" : 15 }
      ],
      membres: []
    }
  },
  methods: {
    mapInitialized(map) {
      global.map = map
      this.mapIsReady = true
    },
    mapLoaded(map) {
      this.membres.forEach(function(marker) {
        var el = document.createElement('div');
        console.log(el)
          el.className = 'marker';
          $('<div @click="popupClicked" class="popup"><span>'+marker.properties.title+'</span></div>').appendTo(el);
          new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
      });

    },
    flyTo (long, lat, zoom, speed) {
        map.flyTo({
          center: [long, lat],
          zoom: zoom, // starting zoom
          speed:500,
          curve: 0.4
        });        
    },
    showMap (mapData) {
      var homeLocationInterval
      var activeMarkerRotation
      var setRotationInterval     
      clearInterval(homeLocationInterval)
      clearInterval(activeMarkerRotation)
      // alert('showMapFired')

      $('.map-container').css('transform','translate3d(0px,0px,0px');
      if (this.mapIsReady) {
        if (mapData.pageType === 'Home') {
          // homeLocationInterval = setInterval( function(){
            var selectedHomeLocation = [9,2,4,10]
            var specialRandomMap = Math.floor(Math.random() * selectedHomeLocation.length)
            var randomMap = selectedHomeLocation[specialRandomMap]
            this.flyTo(this.selectedLocations[randomMap].long, this.selectedLocations[randomMap].lat, this.selectedLocations[randomMap].zoom, 3 )
          // }.bind(this),9000)
        } else {
          clearInterval(homeLocationInterval)
          if (mapData.location) {
            this.flyTo(mapData.location.long, mapData.location.lat, mapData.location.zoom, 3 )
          } else {
            var randomMap = Math.floor(Math.random() * this.selectedLocations.length)  
            this.flyTo(this.selectedLocations[randomMap].long, this.selectedLocations[randomMap].lat, this.selectedLocations[randomMap].zoom, 3 )
          }
          if (mapData.mapMembres){
            this.membres = mapData.mapMembres
          } else {
            this.membres = ''
          }
        }
      }


      if (this.searchPage && this.searchViewMode == 'map'){
        setRotationInterval = function(){
          clearInterval(global.activeMarkerRotation)
          global.activeMarkerRotation = setInterval( function(){
            var selectedMarker1 = Math.round(Math.random() * ($('.mapboxgl-map .mapboxgl-marker').length)) 
            var selectedMarker2 = Math.round(Math.random() * ($('.mapboxgl-map .mapboxgl-marker').length)) 
            var selectedMarker3 = Math.round(Math.random() * ($('.mapboxgl-map .mapboxgl-marker').length)) 

            $('.mapboxgl-map .mapboxgl-marker').removeClass('active')
            setTimeout( function(){
              $('.mapboxgl-map .mapboxgl-marker').eq(selectedMarker1).addClass('active')
            }, 200)
            setTimeout( function(){
              $('.mapboxgl-map .mapboxgl-marker').eq(selectedMarker2).addClass('active')
            }, 350)    
            setTimeout( function(){
              $('.mapboxgl-map .mapboxgl-marker').eq(selectedMarker3).addClass('active')
            }, 700)    
          }, 2000)
        }

        setRotationInterval()

        $('body').on('mouseover','.mapboxgl-map .mapboxgl-marker', function(){
          // alert('ok')
          $('.mapboxgl-map .mapboxgl-marker').removeClass('active')
          clearInterval(global.activeMarkerRotation)
        })

        $('body').on('mouseout','.mapboxgl-map .mapboxgl-marker', function(){
          $('.mapboxgl-map .mapboxgl-marker').removeClass('active')
          setRotationInterval()
        })
      }

    },
    adjustMap () {
      this.isAdjustMap = !this.isAdjustMap
    },
    getMapData () {
      axios.get('https://api.mapbox.com/geocoding/v5/mapbox.places/'+ this.placeToSearch +'.json?access_token=pk.eyJ1IjoiYmVub2l0YiIsImEiOiJjamV6ZG5vaWwwOXd1MnhvaDlyZTRsM2VnIn0.hyAyyxR_bD_XIYiam8rvXg').then(response => {
        console.log('response', response.data)
        var long = response.data.features[0].geometry.coordinates[0]
        var lat = response.data.features[0].geometry.coordinates[1]
        this.flyTo(long, lat, 10, 5)
      })
      .catch(error => {
        console.log(error)
      })
    }
  },
  created () {
    $(window).scroll( function(){
      var scrollPercent = 100 * $(window).scrollTop() / ($(window).height() - $('.left-container').height())
      var mapScrolled = (($('.map-container').height() - $(window).height()) * scrollPercent)/100
      $('.map-container').css('transform','translate3d(0px,'+ (mapScrolled) +'px,0px');
    })
    
    if (app.$route.path.split('/')[1] == 'en'){
      this.lang = 'en'
    }else{
      this.lang = 'fr'
    }
  },
  watch: {
    mapIsReady (val) {
      console.log(val)
    },
    $route () {
      if (app.$route.path.split('/')[1] == 'en'){
        this.lang = 'en'
      }else{
        this.lang = 'fr'
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main.vue